import { Link } from '@components/Link';
import Typography from '@components/Typography';
import { StyledBreadCrumbElement } from './style';

import type React from 'react';

export type BreadCrumbElementProps = {
  text: string;
  link?: string;
};

export const BreadCrumbElement: React.FC<BreadCrumbElementProps> = ({ text: value, link }) => {
  const route = link ? (
    <Link route={link} passHref>
      <Typography type="B2">{value}</Typography>
    </Link>
  ) : (
    <Typography type="B2" as="span">
      {value}
    </Typography>
  );
  return <StyledBreadCrumbElement>{route}</StyledBreadCrumbElement>;
};
